import React, { PropsWithChildren, useEffect, JSX } from 'react';
import LazyLoad, { forceCheck, LazyLoadProps } from 'react-lazyload';
import FadeIn from './FadeIn';

const LazyLoadElement = (
  props: PropsWithChildren<{ forceCheckDeps?: Array<unknown> } & Partial<LazyLoadProps>>
): JSX.Element => {
  const { forceCheckDeps, children, ...lazyLoadProps } = props;

  useEffect(() => {
    setTimeout(() => {
      forceCheck();
    }, 300);
  }, forceCheckDeps);

  return (
    <LazyLoad
      {...lazyLoadProps}
      throttle={lazyLoadProps.throttle ?? 100}
      height={lazyLoadProps.height ?? 100}
    >
      <FadeIn>{children}</FadeIn>
    </LazyLoad>
  );
};

export default LazyLoadElement;
